 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2":"Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2","Teacher~administration":"Teacher~administration","administration":"administration","Teacher~class":"Teacher~class","Teacher":"Teacher","class":"class","announcementDetails":"announcementDetails","announcements":"announcements","circularDetails":"circularDetails","circulars":"circulars","gallery":"gallery","messaging":"messaging","profile":"profile","bank":"bank","chartdisplay":"chartdisplay","clubs":"clubs","conduct":"conduct","contact":"contact","fees":"fees","homework":"homework","meals":"meals","parents":"parents","refund":"refund","school":"school","schoolbus":"schoolbus","staff":"staff","super":"super","termreq":"termreq","welcome":"welcome"}[chunkId]||chunkId) + "." + {"404":"d9173ec3","Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2":"540489db","Teacher~administration":"76ad63d4","administration":"346c7e9c","Teacher~class":"8c3c5ba2","Teacher":"43c54b2e","class":"4c16d1cf","announcementDetails":"95f2c680","announcements":"cab3fdec","circularDetails":"f2993d4b","circulars":"7b3b0d6d","gallery":"932e9bde","messaging":"5b8c43b7","profile":"eca5a285","bank":"c4aa79af","chartdisplay":"99dea656","clubs":"45473078","conduct":"de936741","contact":"d16a32b7","fees":"b8befaad","homework":"f1518fe2","meals":"fde76471","parents":"38eaedec","refund":"c44c5657","school":"9a405111","schoolbus":"5d113451","staff":"40f9d8c6","super":"ea801a0d","termreq":"d62abae1","welcome":"d5bb130d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"Teacher~administration":1,"administration":1,"Teacher~class":1,"Teacher":1,"class":1,"announcementDetails":1,"announcements":1,"circularDetails":1,"circulars":1,"gallery":1,"messaging":1,"profile":1,"bank":1,"chartdisplay":1,"clubs":1,"conduct":1,"contact":1,"fees":1,"homework":1,"meals":1,"parents":1,"refund":1,"school":1,"schoolbus":1,"staff":1,"super":1,"termreq":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2":"Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2","Teacher~administration":"Teacher~administration","administration":"administration","Teacher~class":"Teacher~class","Teacher":"Teacher","class":"class","announcementDetails":"announcementDetails","announcements":"announcements","circularDetails":"circularDetails","circulars":"circulars","gallery":"gallery","messaging":"messaging","profile":"profile","bank":"bank","chartdisplay":"chartdisplay","clubs":"clubs","conduct":"conduct","contact":"contact","fees":"fees","homework":"homework","meals":"meals","parents":"parents","refund":"refund","school":"school","schoolbus":"schoolbus","staff":"staff","super":"super","termreq":"termreq","welcome":"welcome"}[chunkId]||chunkId) + "." + {"404":"7be32b92","Teacher~administration~announcementDetails~announcements~circularDetails~circulars~class~gallery~mes~0e2eeaa2":"31d6cfe0","Teacher~administration":"f9887a7c","administration":"6b7a5b70","Teacher~class":"d1369235","Teacher":"0a1521fe","class":"28782aa0","announcementDetails":"df7b4b9c","announcements":"94b880de","circularDetails":"ecf89674","circulars":"da757669","gallery":"0d9f6eb9","messaging":"0d7c75e3","profile":"98182a07","bank":"f1483edb","chartdisplay":"f16bd5f0","clubs":"27150d53","conduct":"27150d53","contact":"0f9371d0","fees":"a91c48eb","homework":"a25d9242","meals":"aa1c7bd2","parents":"25d39ed4","refund":"fff81952","school":"05f16c22","schoolbus":"a91c48eb","staff":"3fee8742","super":"00c56695","termreq":"f3629b58","welcome":"d69dbb5b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
